export type BlockStatus = 'crecimiento' | 'fuga' | null;

export interface Block {
  id: number;
  label: string;
  activity: string;
  status: BlockStatus;
}

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/tBqp2YGzG9d612EL9n9MHh/Logo_Carolina_Gomez_en_Dorado_corregido.png';

export const WHATSAPP_MENSAJE =
  'Hola Carolina, acabo de hacer mi Mapa de Fugas. Mi nombre es...';
export const WHATSAPP_NUMERO = '584145681906';

const START = 6 * 60;
const END = 22 * 60;
const BLOCK_LEN = 30;

export const TOTAL_BLOCKS = (END - START) / BLOCK_LEN;

function formatLabel(h: number, mi: number): string {
  const hh = h > 12 ? h - 12 : h === 0 ? 12 : h;
  const ap = h >= 12 ? 'pm' : 'am';
  return `${hh}${mi === 0 ? ':00' : ':30'}${ap}`;
}

export function createBlocks(): Block[] {
  const blocks: Block[] = [];
  for (let m = START; m < END; m += BLOCK_LEN) {
    blocks.push({
      id: m,
      label: formatLabel(Math.floor(m / 60), m % 60),
      activity: '',
      status: null,
    });
  }
  return blocks;
}
